module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-board-preview-survey-form"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.previewSize),
      callback: function($$v) {
        _vm.previewSize = $$v
      },
      expression: "previewSize"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1300"
    }
  }, [_vm._v("Desktop")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1000"
    }
  }, [_vm._v("Tablet")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "412"
    }
  }, [_vm._v("Mobile")])], 1)], 1), _vm._v(" "), (!_vm.survey.isPreview) ? _c('div', {
    staticClass: "row text-center"
  }, [_vm._v("\n    Published Link:\n    "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.publishedUrl
    }
  }, [_vm._v(_vm._s(_vm.publishedUrl))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_vm._v("\n    External Preview Link:\n    "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.previewUrl
    }
  }, [_vm._v(_vm._s(_vm.previewUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('iframe', {
    ref: "previewFrame",
    attrs: {
      "src": _vm.previewUrl,
      "width": _vm.previewSize,
      "height": "600",
      "frameborder": "0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.survey.isPreview,
      "loading": _vm.surveySaving
    },
    on: {
      "click": _vm.handlePublish
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square-o"
  }), _vm._v(" " + _vm._s(_vm.publishedTitle()) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47117e3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/tabs/PreviewTab.vue
// module id = 3260
// module chunks = 3